import { handleActions } from 'redux-actions';
import { setNextFormStep, setPreviousFormStep, setInitialFormStep } from 'actions/form';

const initialState: any = 1;

const reducer = handleActions(
  {
    [setNextFormStep as any]: (state: any) => state + 1,
    [setPreviousFormStep as any]: (state: any) => (state > 1 ? state - 1 : 1),
    [setInitialFormStep as any]: () => 1,
  },
  initialState
);

export default reducer;
